export const SESSION_READY = 'SESSION_READY'; // отсылает GAME движок
export const NEW_TURN = 'NEW_TURN'; // отсылает GAME движок
export const END_TURN = 'END_TURN'; // отсылает GAME движок
export const GAMEOVER = 'GAMEOVER'; // отсылает GAME движок
export const SET_BUFF = 'SET_BUFF'; // отсылает UI
export const SETTED_BUFF = 'SET_BUFF'; // отсылает GAME движок

export const PLAYER_CHOOSE_MOVE = 'PLAYER_CHOOSE_MOVE'; // отсылает GAME движок
export const MOVE_ANIMATION_MIDDLE = 'MOVE_ANIMATION_MIDDLE'; // отсылает GAME движок
export const MOVE_ANIMATION_END = 'MOVE_ANIMATION_END'; // отсылает GAME движок
export const POST_ANIMATION_END = 'POST_ANIMATION_END'; // отсылает GAME движок

export const CAVE_START = 'CAVE_START';

export const SPEED_INSANE = 0;
export const SPEED_HARD = 1;
export const SPEED_FAST = 2;
export const SPEED_MIDDLE = 3;
export const SPEED_SLOW = 4;

export const SPEED_LINE = [
    { thinkBaseTime: 0.55, thinkSlow: 0.05 }, // INSANE
    { thinkBaseTime: 0.95, thinkSlow: 0.15 }, // HARD
    { thinkBaseTime: 1.5, thinkSlow: 0.3 }, // FAST
    { thinkBaseTime: 2.5, thinkSlow: 1 }, // MIDDLE
    { thinkBaseTime: 5, thinkSlow: 1 } // SLOW
]

export const randomTo = ( from = 0, to = 2) => from + Math.floor((Math.random() - 0.0000005) * (to + 1 - from));